// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file NavaidList.proto (package NavaidList, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Navaid } from "./Navaid_pb";
import { file_Navaid } from "./Navaid_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file NavaidList.proto.
 */
export const file_NavaidList: GenFile = /*@__PURE__*/
  fileDesc("ChBOYXZhaWRMaXN0LnByb3RvEgpOYXZhaWRMaXN0Ii4KCk5hdmFpZExpc3QSIAoIZW50aXRpZXMYASADKAsyDi5OYXZhaWQuTmF2YWlkQkAKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIPTmF2YWlkTGlzdFByb3RvYgZwcm90bzM", [file_Navaid]);

/**
 * @generated from message NavaidList.NavaidList
 */
export type NavaidList = Message<"NavaidList.NavaidList"> & {
  /**
   * @generated from field: repeated Navaid.Navaid entities = 1;
   */
  entities: Navaid[];
};

/**
 * Describes the message NavaidList.NavaidList.
 * Use `create(NavaidListSchema)` to create a new message.
 */
export const NavaidListSchema: GenMessage<NavaidList> = /*@__PURE__*/
  messageDesc(file_NavaidList, 0);

